/**
 * Created by comoon on 11/6/15.
 */

(function () {

    window.sjb = window.sjb || {};

    var sjb = window.sjb;

    sjb.messaging = sjb.messaging || {};

    sjb.messaging.comoon = sjb.messaging.comoon || {};

    var events = sjb.messaging.comoon.events = {};

    events.CMEvent = function CMEvent() {

        var self = this;

        var onStore = {};

        var onceStore = {};

        self.on = function (name, callback, context) {

            add(onStore, name, callback, context);

            return self;
        };

        self.once = function (name, callback, context) {

            add(onceStore, name, callback, context);

            return self;
        };

        self.off = function (name, callback) {

            if (callback) {

                var index;

                var runner;

                if (onStore.hasOwnProperty(name)) {

                    for (index = 0; index < onStore[name].length; index++) {

                        runner = onStore[name][index];

                        if (runner.callback === callback) {

                            onStore[name].splice(index, 1);

                            break;
                        }
                    }
                }

                if (onceStore.hasOwnProperty(name)) {

                    for (index = 0; index < onceStore[name].length; index++) {

                        runner = onceStore[name][index];

                        if (runner.callback === callback) {

                            onceStore[name].splice(index, 1);
                        }
                    }
                }

            } else if (name) {

                if (onStore.hasOwnProperty(name)) {

                    delete onStore[name];
                }

                if (onceStore.hasOwnProperty(name)) {

                    delete onceStore[name];
                }
            } else {

                onStore = {};

                onceStore = {};
            }

            return self;
        };

        self.trigger = self.emit = function (name, data, context) {

            var toImplement = [];

            if (name) {

                if (onceStore.hasOwnProperty(name)) {

                    toImplement = toImplement.concat(onceStore[name]);

                    delete onceStore[name];
                }

                if (onStore.hasOwnProperty(name)) {

                    toImplement = toImplement.concat(onStore[name]);
                }

            } else {

                var k;

                for (k in onStore) {

                    toImplement = toImplement.concat(onStore[k]);
                }

                for (k in onceStore) {

                    toImplement = toImplement.concat(onceStore[k]);
                }

                //reset once store
                onceStore = {};
            }

            for (var idx = 0; idx < toImplement.length; idx++) {

                var runner = toImplement[idx];

                var result = runner.callback.apply(runner.context || context || self, data || []);

                if (result === false) {

                    break;
                }
            }

            return self;
        };

        return self;
    };


    function add(store, name, callback, context) {

        if (!callback) {

            callback = name;
        }

        if (typeof callback !== 'function') {

            throw `[${callback}] is not a function`;
        }

        var runner = {callback: callback, context: context};

        if (store[name]) {

            store[name].push(runner);

        } else {

            store[name] = [runner];
        }
    }


    if (typeof module === 'object' && typeof require === 'function') {

        module.exports = events;
    }

})();


/** WEBPACK FOOTER **
 ** ./script/lib/CMEvent.js
 **/